const CryptoJS = require("crypto-js");

module.exports = function encrypt({ data, initVector, Securitykey }) {
  var options = { mode: CryptoJS.mode.CBC, iv: initVector };
  return CryptoJS.AES.encrypt(data, Securitykey, options).toString();
};
